module.exports = __webpack_public_path__ + "b12ef55278628ed69bb619d2f8fc22be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_32.jpg
// module id = 1742
// module chunks = 5